import config from "./config";

let ip = 'localhost'

export default {
    ...config,
    metrics: true,
    debug: true,
    ssl: false,
    checkSoon: host => false,
    directives: {
        connectSrc: [
            ip + ":20011", ip + ":20010", ip + ":20012",
            "*.elfsight.com", "www.google-analytics.com", "mc.yandex.ru",
            "www.google.com", "analytics.google.com", '*.clarity.ms'
        ],
        imgSrc: [
            "blob:", ip + ":20012", ip + ":20010",
            "*.tripadvisor.com", "*.facebook.com",
            "*.google.az", 'www.google.com', 'static.elfsight.com'
        ],
        fontSrc: [
            "data:"
        ],
        frameSrc: [
            '*.google.com', 'mc.yandex.ru', 'td.doubleclick.net', 'www.googletagmanager.com', 'js.stripe.com'
        ],
        frameAncestors: [
            "'self'",
            "localhost:21010"
        ],
        formAction: ["*"]
    },
    urls: {
        api: ip + ':20011',
        cdn: ip + ':20012',
        site: ip + ':20010'
    },
    serverIp: ['127.0.0.1', '::1', ip],
    siteOrigin: ['http://' + ip + ':20010'],
    recaptchaKey: '6LdbymApAAAAAHLsj5azwe-RWtfYjL1jMMEITFtc'
}
